module.exports = __webpack_public_path__ + "img/ai_icon3.8a080301.png";